import { gql } from '@apollo/client';

const GET_LEGAL_DOCUMENT_FILE_URL = gql`
  query GetLegalDocumentFileURL($legalDocumentId: Int!) {
    legalDocumentFileUrl(legalDocumentId: $legalDocumentId)
  }
`;

export default GET_LEGAL_DOCUMENT_FILE_URL;
